import React from "react";
import { FormattedMessage } from "react-intl";
import AddressInput, { type IAddressInputProps } from "./AddressInput";

export interface IAddress1InputProps extends IAddressInputProps {}

export default (props: IAddress1InputProps) => {
  const { label = <FormattedMessage id="contacts.address1" /> } = props;

  return <AddressInput {...props} label={label} />;
};
